<div class="modal-header d-flex align-items-center">
  <h5 class="modal-title">
    {{ title }}
  </h5>
  <div>
    <button
      class="btn btn-icon"
      type="button"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="confirmClose()"
      tabindex="-1">
      <i class="fal fa-times"></i>
    </button>
  </div>
</div>
<form novalidate #newAreaForm="ngForm" (ngSubmit)="onAdd(newAreaForm)">
  @if (this.isloaderVisible) {
    <div>
      <div class="d-flex align-items-center justify-content-center" style="height: 70px">
        <div class="loading"></div>
      </div>
    </div>
  } @else {
    <div class="modal-body">
      @if (isNoContentMessageVisible || errorMessage) {
        <div>
          <div role="alert" class="alert alert-danger">
            <i class="fas fa-exclamation pe-2"></i>
            @if (isNoContentMessageVisible) {
              A Category with the name&nbsp;<span class="font-weight-medium">{{ areaName }}</span
              >&nbsp;already exists in the system.
            } @else {
              {{ errorMessage }}
            }
            <i class="far fa-times ms-auto pt-1" (click)="resetErrors()"></i>
          </div>
        </div>
      }
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label class="form-control-label" for="name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              name="name"
              style="width: 100%"
              [(ngModel)]="newArea.name"
              required
              #name="ngModel"
              [ngClass]="{
                'is-invalid':
                  ((name.touched || name.dirty) && !name.valid) ||
                  (!name.valid && newAreaForm.submitted),
              }" />
            <span class="invalid-feedback">
              @if (name.errors?.required) {
                <span> Please enter Category name. </span>
              }
            </span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <wre-toolkit-toggle-switch
              name="isActive"
              #isActive="ngModel"
              [(ngModel)]="newArea.isActive"
              labelText="Active">
            </wre-toolkit-toggle-switch>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="modal-footer border-top">
    <button type="submit" class="btn btn-primary ms-3">
      <span>{{ buttonAction }}</span>
    </button>
  </div>
</form>
